// Small RACI pill: 18px avatar + name + tiny R/A/C/I role badge.
// Used in TaskDetail's right rail (RACI section) and anywhere a
// single owner needs to render with their role.

import { Avatar } from './Avatar.jsx';

export const MultiOwnerPill = ({ owner, staff }) => {
  const s = staff.find(x => x.id === owner.staffId);
  const isPrimary = owner.role === 'R' && owner.isPrimary;
  const title = s
    ? `${s.name} · ${s.title}${isPrimary ? ' · 主负责人' : ''}`
    : owner.staffId;
  return (
    <div className={`multi-owner-pill${isPrimary ? ' is-primary' : ''}`} title={title}>
      {isPrimary && <span className="multi-owner-star" aria-label="主负责人">★</span>}
      <Avatar staff={s}/>
      <span className="multi-owner-name">{s?.name || owner.staffId}</span>
      <span className={`multi-owner-role role-${owner.role}`}>{owner.role}</span>
    </div>
  );
};
